import { lazy } from 'react';
import type { AppManifest } from '@/apps/types';

/**
 * Solitaire — Klondike, as shipped with every copy of Windows since 3.0.
 *
 * Not a singleton: XP let you open a second game while the first was still
 * half-played, and there is no reason to be stricter than Windows was.
 *
 * The default size is the one the real window opened at — wide enough for
 * seven columns of cards with the stock and the four foundations above them.
 * It takes no launch arguments.
 */
export const solitaireApp: AppManifest = {
  id: 'solitaire',
  name: 'Solitaire',
  icon: '/assets/icons/solitaire.svg',
  component: lazy(() => import('./Solitaire')),

  defaultSize: { w: 700, h: 520 },
  minSize: { w: 600, h: 440 },
  resizable: true,
  maximizable: true,
  singleton: false,

  group: 'Games',
  titleFor: () => 'Solitaire',
};
